module.exports = __webpack_public_path__ + "static/media/galerija_2017 (20).118ce7fe.jpg";